import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import {useCallback,useState,useEffect}from'react';/**
 * Like useState, but with values persisted and loaded from sessionStorage
 *
 * If sessionStorage is not available, it will behave just like useState
 *
 * @export
 * @param {*} key The sessionStorage key
 * @param {*} initialValue The initial value to use if there is no value in sessionStorage for the provided key
 * @returns {[*, React.Dispatch<*>]} An array where the first element is the value, and the second is a function to update the value
 */
function useSessionStorage(key, initialValue) {
  var getSessionStorageValue = useCallback(function () {
    try {
      var existingValueString = sessionStorage.getItem(key);
      return JSON.parse(existingValueString);
    } catch (_unused) {
      // This could happen if accessing session storage fails
      // or the value could not be parsed
      return undefined;
    }
  }, [key]);
  var _useState = useState(getSessionStorageValue() || initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    rawValue = _useState2[0],
    setRawValue = _useState2[1];
  useEffect(function () {
    setRawValue(getSessionStorageValue() || initialValue);
  }, [getSessionStorageValue, initialValue]);
  var setValue = useCallback(function (newValue) {
    var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setRawValue(newValue);
    if (persist) {
      try {
        var stringifiedValue = JSON.stringify(newValue);
        sessionStorage.setItem(key, stringifiedValue);
      } catch (_unused2) {
        // Do nothing, the value will still be set in memory
        // This could happen if accessing session storage fails
        // or the value could not be parsed
      }
    }
  }, [key]);
  return [rawValue, setValue];
}export{useSessionStorage as default};